<template>
  <div>
    <flat-pickr v-model="localValue" :config="config" ></flat-pickr>
  </div>
</template>

<script>
  import FlatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/plugins/monthSelect/style.css'
  import monthSelect from 'flatpickr/dist/plugins/monthSelect'
  import customMixin from '@/mixins/customMixin'
  export default {
    name:'VbdatapickerMonth',
    props:{
      value: {
        type: String, 
			},
      
    },
    mixins : [customMixin],
    components: {
      FlatPickr
    },
    data: function(){
      return{
        localValue: this.value,
        config: {
         
          dateFormat: 'Y',
         
          locale: { 
            firstDayOfWeek: 1,
            weekdays: {
              shorthand: this.shortHandDia(),
              longhand: this.longHandDia(),         
            }, 
            months: {
              shorthand: this.shortHandMes(),
              longhand: this.longHandMes(),
            },
          },//locale
         
          plugins: [new monthSelect({
            shorthand: true, //defaults to false
            dateFormat: "m.Y", //defaults to "F Y"
            altFormat: "F Y", //defaults to "F Y"
          })],
                  
        },   //config
        
      }//return
    },
    mounted(){
     //
    },
    watch:{
			localValue (newValue) {
		    this.$emit('input', newValue)
			},
			value (newValue) {
       	this.localValue = newValue
     	}
		},
    methods:{
      //
    }
    
        
  }
</script>

<style lang="scss" scoped>

</style>